<template>
  <div v-if="isInstallable && !isInstalled && !dismissed" class="install-pwa-container">
    <div class="install-pwa-prompt">
      <div class="install-pwa-content">
        <h3>Add to Home Screen</h3>
        <p>Install FMD Freight on your device for quick access and a better experience.</p>
        <div class="install-pwa-actions">
          <button @click="dismiss" class="btn-secondary">Not Now</button>
          <button @click="install" class="btn-primary">Install</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { useInstallPrompt } from '@/composables/useInstallPrompt';

const { isInstallable, isInstalled, showInstallPrompt } = useInstallPrompt();
const dismissed = ref(false);

const install = () => {
  showInstallPrompt();
};

const dismiss = () => {
  dismissed.value = true;
};
</script>

<style scoped>
.install-pwa-container {
  position: fixed;
  bottom: 20px;
  left: 20px;
  right: 20px;
  z-index: 1000;
}

.install-pwa-prompt {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  padding: 16px;
  max-width: 400px;
  margin: 0 auto;
}

.install-pwa-content h3 {
  margin-top: 0;
  color: #4f46e5;
}

.install-pwa-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 16px;
}

.btn-primary {
  background-color: #4f46e5;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 500;
}

.btn-secondary {
  background-color: transparent;
  color: #6b7280;
  border: 1px solid #d1d5db;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 500;
}

/* Make sure the component is responsive */
@media (max-width: 640px) {
  .install-pwa-container {
    bottom: 10px;
    left: 10px;
    right: 10px;
  }
  
  .install-pwa-prompt {
    padding: 12px;
  }
  
  .install-pwa-actions {
    flex-direction: column;
    gap: 8px;
  }
  
  .btn-primary, .btn-secondary {
    width: 100%;
  }
}
</style>
